import {
  Box,
  Button,
  Flex,
  IMAGE_PREVIEW_BUTTON_DEFAULT_WIDTH,
  Image,
  ImagePreviewButton,
  Text,
  theme,
} from '@/components';
import { CloseOutlined, PaperClipOutlined } from '@ant-design/icons';
import { type FC, useCallback } from 'react';

import type { FileEntry } from '../../models/upload';

const BUTTON_HEIGHT = 22;

export const CommentReplyUploadList: FC<{
  fileEntries: Array<FileEntry>;
  onRemove?: (url: string) => void;
}> = ({ fileEntries, onRemove }) => {
  if (fileEntries.length === 0) {
    return null;
  }

  return (
    <Image.PreviewGroup>
      <Flex vertical gap={4}>
        {fileEntries.map((fileEntry) => (
          <UploadListItem
            key={fileEntry.attachment?.id ?? fileEntry.url}
            fileEntry={fileEntry}
            onRemove={onRemove}
          />
        ))}
      </Flex>
    </Image.PreviewGroup>
  );
};

const UploadListItem: FC<{
  fileEntry: FileEntry;
  onRemove?: (url: string) => void;
}> = ({ fileEntry, onRemove }) => {
  const { token } = theme.useToken();

  const handleRemove = useCallback(() => {
    onRemove?.(fileEntry.url);
  }, [fileEntry.url, onRemove]);

  return (
    <Flex align="center" justify="space-between" gap={4}>
      <PaperClipOutlined
        style={{ fontSize: 16, color: token.colorTextSecondary }}
      />
      <Box flex={1} overflow="hidden">
        <Text
          text={fileEntry.attachment?.fileName ?? fileEntry.file?.name}
          maxRows={1}
        />
      </Box>
      {!!fileEntry.url &&
      (fileEntry.file?.type.startsWith('image') ||
        fileEntry.attachment?.fileContentType.startsWith('image')) ? (
        <ImagePreviewButton previewURL={fileEntry.url} />
      ) : (
        <Box width={IMAGE_PREVIEW_BUTTON_DEFAULT_WIDTH} />
      )}
      <Button
        icon={<CloseOutlined />}
        size="small"
        type="text"
        style={{ color: token.colorTextSecondary, height: BUTTON_HEIGHT }}
        onClick={handleRemove}
      />
    </Flex>
  );
};
